import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=0a2ee1c8&"
import script from "./Signature.vue?vue&type=script&lang=ts&"
export * from "./Signature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports